export enum InterationViewFiltersEnum {
    interactionType = 'interationType',
    interactionDate = 'interactionDate',
    interactionUser = 'interationUser'
}
